import {Toaster as SonnerToaster} from "sonner";

export function Toaster() {
    return <SonnerToaster theme="dark" position="top-right" richColors closeButton/>
}
